import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import CoachingPlanSource from 'sources/coaching/CoachingPlanSource';

class CoachingPlanActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'update',
        'create',
        'endPlan',
        'retrieve',
        'fetchAll',
        'fetchForCoaches',
        'fetchForDirectReports',
        'fetchForManagerWithReviewsInRange',
        'fetchLastCompleteAndOverdue'
      )
    );
  }

  update(plan) {
    const saveMe = removeUserInfo(plan);

    return dispatch => {
      dispatch(saveMe);
      return CoachingPlanSource.update(saveMe).then(this.updateSuccess, error => {
        this.updateError();
        throw error;
      });
    };
  }

  create(plan) {
    const saveMe = removeUserInfo(plan);

    return dispatch => {
      dispatch(saveMe);
      return CoachingPlanSource.create(saveMe).then(
        // return the plan with the id returned from the API
        // but not the version with no user info
        noInfoPlan => this.createSuccess(plan.set('id', noInfoPlan.id)),
        error => {
          this.createError.defer();
          throw error;
        }
      );
    };
  }

  endPlan(planId) {
    return dispatch => {
      dispatch(planId);
      // not hooked up to anything in the store. We just refresh.
      return CoachingPlanSource.delete(planId);
    };
  }

  retrieve(planId, params = {includeReviews: true}) {
    return dispatch => {
      dispatch(planId);
      return CoachingPlanSource.retrieve(planId, params).then(this.retrieveSuccess, error => {
        throw error;
      });
    };
  }

  fetchAll(params) {
    return dispatch => {
      dispatch(params);
      return CoachingPlanSource.fetchAll(params).then(this.fetchAllSuccess, e => {
        this.fetchAllError();
        throw e;
      });
    };
  }

  fetchForCoaches(coachIds, params) {
    return dispatch => {
      dispatch(coachIds, params);
      return CoachingPlanSource.fetchForCoaches(coachIds, params).then(this.fetchAllSuccess, e => {
        this.fetchAllError();
        throw e;
      });
    };
  }

  fetchForDirectReports(managerId) {
    return dispatch => {
      dispatch(managerId);
      return CoachingPlanSource.fetchAll({
        coachId: managerId,
        managerId,
        includeReviews: true,
        includeCompleted: false,
        includeReviewCoach: true,
      }).then(this.fetchAllSuccess, e => {
        this.fetchAllError();
        throw e;
      });
    };
  }

  fetchForManagerWithReviewsInRange(start, end) {
    return dispatch => {
      dispatch(start, end);
      return CoachingPlanSource.fetchForManagerWithReviewsInRange(start, end).then(
        this.fetchForManagerWithReviewsInRangeSuccess,
        this.fetchForManagerWithReviewsInRangeError
      );
    };
  }

  fetchLastCompleteAndOverdue(coachIds, endDate) {
    return dispatch => {
      dispatch(coachIds);
      return CoachingPlanSource.fetchLastCompleteAndOverdue(coachIds, endDate).then(
        this.fetchLastCompleteAndOverdueSuccess,
        this.fetchLastCompleteAndOverdueError
      );
    };
  }
}

function removeUserInfo(plan) {
  return plan.setIn(['recipient', 'info'], null).setIn(['coach', 'info'], null);
}

export default alt.createActions(CoachingPlanActions);
